import { ApiEndpoints } from "@shared/api/api-endpoints";
import { onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import {
  CreateSystemType,
  CreateSystemTypeParameter,
  UpdateSystemTypeParameter,
} from "./types";

export const axSystemTypesApi = {
  createSystemType: async (
    data: CreateSystemType
  ): Promise<CreateSystemType> => {
    const payload = {
      name: data.name,
      remote_utility_id: data.remote_utility_id,
      description: data.description,
      code: data.code,
    };

    try {
      const response = await onboardingApiClient.post(
        "config-map/system_json/",
        payload
      );
      return response.data.result || response.data;
    } catch (error) {
      throw error;
    }
  },
  updateSystemType: async (payload: any) => {
    const response = await onboardingApiClient.patch(
      "config-map/system_json/",
      payload
    );
    return response.data.result || response.data;
  },
  getSystemType: async (
    remoteUtilityId: number,
    configLevel?: string,
    showInactive?: boolean
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/system_json",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("config_level", configLevel);
        query.push("show_inactive", showInactive);
        return query;
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data.result ?? [];
  },
  searchSystemType: async (
    remoteUtilityId: number,
    searchField?: string,
    searchData?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "search/onboarding_config",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("search_field", searchField);
        query.push("search_data", searchData);
        return query;
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data.result ?? [];
  },
  createSystemTypeParameter: async (
    data: any
  ): Promise<CreateSystemTypeParameter> => {
    try {
      const response = await onboardingApiClient.post(
        "config-map/system_json/",
        data
      );
      return response.data.result || response.data;
    } catch (error) {
      throw error;
    }
  },
  updateSystemTypeParameter: async (data: UpdateSystemTypeParameter) => {
    const payload = {
      name: data.name,
      remote_utility_id: data.remote_utility_id,
      description: data.description,
      unit: data.unit,
      code: data.code,
      value: data.value,
    };

    try {
      const response = await onboardingApiClient.patch(
        "config-map/system_json/",
        payload
      );
      return response.data.result || response.data;
    } catch (error) {
      throw error;
    }
  },
  getSystemTypeParameter: async (
    remoteUtilityId: number,
    configLevel?: string,
    showInactive?: boolean,
    codeList?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/system_json",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("config_level", configLevel);
        query.push("show_inactive", showInactive);
        query.push("code_list", codeList);
        return query;
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data.result ?? [];
  },
  deleteSystemType: async (data: { remoteUtilityId: number; code: string }) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/system_json",
      (query) => {
        query.push("remote_utility_id", getRemoteUtilityId());
        query.push("code", data.code);
        return query;
      }
    );

    try {
      const response = await onboardingApiClient.delete(url);
      return response.data.result ?? [];
    } catch (error) {
      throw error;
    }
  },
  toggleSystemType: async (data: {
    remoteUtilityId: number;
    code: string;
    isActive: boolean;
  }) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/system_json"
    );

    try {
      const response = await onboardingApiClient.patch(url, data);
      return response.data.result ?? [];
    } catch (error) {
      throw error;
    }
  },
};
